import { render, staticRenderFns } from "./ResizableTextArea.vue?vue&type=template&id=1c6ce6da&scoped=true&"
import script from "./ResizableTextArea.vue?vue&type=script&lang=js&"
export * from "./ResizableTextArea.vue?vue&type=script&lang=js&"
import style0 from "./ResizableTextArea.vue?vue&type=style&index=0&id=1c6ce6da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6ce6da",
  null
  
)

export default component.exports